
export default function EditAssessmentDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
) {
  const vm = this;

  vm.isAdd = false;
  vm.hasMultipleTemplates = false;
  vm.criTierLevels = [];
  
  vm.handleCloseDialog = _handleCloseDialog;

  vm.handleTemplateChange = _handleTemplateChange;
  vm.handleEditAssessmentFormSubmit = _handleEditAssessmentFormSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {

    vm.criTierLevels = ecatSharedModelService.criTierLevels;

    if (vm.templates.length > 1) {
      vm.hasMultipleTemplates = true;
    } 

    if(vm.assessment.assessmentId <= 0){
      vm.isAdd = true;
      vm.assessment.templateId = vm.templates[0].templateId;
      vm.assessment.templateName = vm.templates[0].name;
      vm.assessment.usesCRIProfile = vm.templates[0].usesCRIProfile;
    } else {      
      angular.forEach(vm.templates, (template) => {
        if (template.templateId === vm.assessment.templateId) {
          vm.assessment.templateName = template.name;
          vm.assessment.usesCRIProfile = template.usesCRIProfile;
        }
      });
      
      angular.forEach(vm.criTierLevels, (criTierLevel) => {
        if (criTierLevel.criTierLevelId === vm.assessment.criTierLevelId) {
          vm.assessment.criTierLevelValue = criTierLevel.name;
        }
      });
    }
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.editAssessmentDialog);
  }

  function _handleTemplateChange() { 
    const newTemplateId = vm.assessment.templateId;

    angular.forEach(vm.templates, (template) => {
      if (template.templateId === newTemplateId) {
        vm.assessment.templateName = template.name;
        vm.assessment.usesCRIProfile = template.usesCRIProfile;
      }
    });
  }

  function _handleEditAssessmentFormSubmit() {
    const dfdSave = $q.defer();

    if ($scope.editECATAddAssessmentForm.$valid) {
      loaderService.showViewLoader = true;
      ecatDataService.saveAssessment(vm.assessment.assessmentId, vm.assessment.name, vm.assessment.templateId, vm.assessment.criTierLevelId).then((response) => {
        loaderService.showViewLoader = false;
        const savedAssessmentId = response.data;

        if (savedAssessmentId === 0) {
          alerts.error('An error occurred while saving the Assessment.');
          dfdSave.reject();
        } else {
          vm.assessment.assessmentId = savedAssessmentId;
          alerts.success('The Assessment has been saved successfully.');
          _handleCloseDialog();
          dfdSave.resolve();
        }

        $rootScope.$broadcast('refreshECATAssessments');
      });
    } else {
      dfdSave.reject();
    }

    return dfdSave.promise;
  }
}

EditAssessmentDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'loaderService',
  'ssDialogService',
];
